import { render, staticRenderFns } from "./AbonoTableComponent.vue?vue&type=template&id=0b04f967&"
import script from "./AbonoTableComponent.vue?vue&type=script&lang=js&"
export * from "./AbonoTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports